/** Minste brukbare målespenn for denne tanken; ikke en garanti for fysisk kalibrering. */
export const MIN_VANN_SPENN_MM = 20;
/** ESP32 sender normalt hvert femte minutt. */
export const KALIBRERING_MAKS_ALDER_MS = 6 * 60_000;

export function vannKalibreringFeil(tomMm: number, fullMm: number): string | null {
  if (!Number.isFinite(tomMm) || !Number.isFinite(fullMm) || fullMm <= 0 || tomMm <= 0) {
    return 'Kalibreringen må ha positive, gyldige millimeterverdier.';
  }
  if (tomMm <= fullMm) return 'Tom tank skal gi større avstand enn full tank.';
  if (tomMm - fullMm < MIN_VANN_SPENN_MM) {
    return `Bare ${tomMm - fullMm} mm mellom tom og full. Minst ${MIN_VANN_SPENN_MM} mm kreves for denne tanken. Kontroller at flottøren beveger seg fritt og at laseren måler flottøren.`;
  }
  return null;
}

/** Kalibrering skal bruke en avlesning tatt ETTER at brukeren startet målingen. */
export function kalibreringsMaalingFeil(
  mm: number | null | undefined,
  registrertAt: string | null | undefined,
  startetAt: number,
  naa: number,
): string | null {
  if (mm == null || !Number.isFinite(mm) || mm <= 0) return 'Venter på en gyldig avstand fra vannmåleren.';
  const t = registrertAt ? Date.parse(registrertAt) : NaN;
  if (!Number.isFinite(t) || t < startetAt) return 'Venter på en ny avlesning. Det kan ta opptil fem minutter.';
  if (t > naa + 60_000 || naa - t > KALIBRERING_MAKS_ALDER_MS) {
    return 'Avlesningen er for gammel eller har feil tidspunkt. Vent på en ny måling fra kassa.';
  }
  return null;
}
